import {NgModule} from '@angular/core';
import {RouterModule, Routes} from '@angular/router';
import {AuthGuard} from '@app/app/shared/guards/auth.guard';
import {LoginComponent} from '@app/app/login/login.component';
import {ForgotPasswordComponent} from '@app/app/forgot-password/forgot.password.component';
import {ResetPasswordComponent} from '@app/app/reset-password/reset.password.component';
import {ManufacturerComponent} from '@app/app/manufacturer/manufacturer.component';
import {ControllerComponent} from '@app/app/controller/controller.component';
import {ProfileComponent} from '@app/app/profile/profile.component';
import {AdminGuard} from '@app/app/shared/guards/admin.guard';
import {AdminOrClientGuard} from '@app/app/shared/guards/admin.or.client.guard';
import {AdminOrManufacturerGuard} from '@app/app/shared/guards/admin.or.manufacturer.guard';
import {ParksComponent} from '@app/app/dashboard/parks/parks.component';
import {AlarmsComponent} from '@app/app/alarms/alarms.component';
import {ReportsComponent} from '@app/app/reports/reports.component';
import {ManufacturersComponent} from '@app/app/manufacturers/manufacturers.component';
import {AdminsComponent} from '@app/app/admins/admins.component';
import {ClientsComponent} from '@app/app/clients/clients.component';
import {EmployeesComponent} from '@app/app/employees/employees.component';
import {ReportsCrowdComponent} from '@app/app/reports/crowd/reports.crowd.component';
import {ReportsAlarmsComponent} from '@app/app/reports/alarms/reports.alarms.component';
import {ReportsHardwareComponent} from '@app/app/reports/hardware/reports.hardware.component';
import {ReportsMapComponent} from '@app/app/reports/map/reports.map.component';
import {ReportsConsoComponent} from '@app/app/reports/conso/reports.conso.component';
import {AdminOrClientOrEmployeeGuard} from '@app/app/shared/guards/admin.or.client.or.employee.guard';
import {ProUserGuard} from '@app/app/shared/guards/pro.user.guard';
import {AccessComponent} from '@app/app/access/access.component';

const routes: Routes = [
  /**
   * Public pages
   */
  {path: 'login', component: LoginComponent},
  {path: 'logout', component: LoginComponent},
  {path: 'forgot-password', component: ForgotPasswordComponent},
  {path: 'reset-password/:token', component: ResetPasswordComponent},
  {path: 'level-of-access', component: AccessComponent},

  /**
   * Logged in users
   */
  {path: 'profile', component: ProfileComponent, canActivate: [AuthGuard]},

  /**
   * Admins only
   */
  {path: 'admins', component: AdminsComponent, canActivate: [AuthGuard, AdminGuard]},
  {path: 'manufacturers', component: ManufacturersComponent, canActivate: [AuthGuard, AdminGuard]},

  /**
   * Admins and Manufacturers
   */
  {path: 'controllers/:id', component: ControllerComponent, canActivate: [AuthGuard, AdminOrManufacturerGuard]},
  {path: 'controllers/new', component: ControllerComponent, canActivate: [AuthGuard, AdminOrManufacturerGuard]},
  {path: 'controllers', component: ManufacturerComponent, canActivate: [AuthGuard, AdminOrManufacturerGuard]},
  {path: 'clients', component: ClientsComponent, canActivate: [AuthGuard, AdminOrManufacturerGuard]},

  /**
   * Admins and Clients
   */
  {path: 'employees', component: EmployeesComponent, canActivate: [AuthGuard, AdminOrClientGuard]},

  /**
   * Admins, Clients and Employees
   */
  {path: 'dashboard', redirectTo: 'dashboard/1'},
  {path: 'dashboard/:page', component: ParksComponent, canActivate: [AuthGuard, AdminOrClientOrEmployeeGuard]},
  {path: 'alarms', component: AlarmsComponent, canActivate: [AuthGuard, AdminOrClientOrEmployeeGuard, ProUserGuard]},
  {path: 'reports', redirectTo: 'reports/crowd'},
  {path: 'reports/crowd', component: ReportsCrowdComponent, canActivate: [AuthGuard, AdminOrClientOrEmployeeGuard, ProUserGuard]},
  {path: 'reports/alarms', component: ReportsAlarmsComponent, canActivate: [AuthGuard, AdminOrClientOrEmployeeGuard, ProUserGuard]},
  {path: 'reports/hardware', component: ReportsHardwareComponent, canActivate: [AuthGuard, AdminOrClientOrEmployeeGuard, ProUserGuard]},
  {path: 'reports/conso', component: ReportsConsoComponent, canActivate: [AuthGuard, AdminOrClientOrEmployeeGuard, ProUserGuard]},
  {path: 'reports/map', component: ReportsMapComponent, canActivate: [AuthGuard, AdminOrClientOrEmployeeGuard, ProUserGuard]},
  {path: 'reports/:type', component: ReportsComponent, canActivate: [AuthGuard, AdminOrClientOrEmployeeGuard, ProUserGuard]},

  // otherwise redirect to home
  {path: '**', redirectTo: 'login'}
];

@NgModule({
  imports: [
    RouterModule.forRoot(routes)
  ]
})
export class MainRoutingModule {
}



// WEBPACK FOOTER //
// ./src/app/main/main.routing.module.ts